import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable, shareReplay } from 'rxjs';
import { AppConfig } from 'src/app/_config/app.config';
import { StorageService } from 'src/app/_services/storage.service';
import { RoleUiPb } from 'src/app/com/staybloom/common/uiproto/roleUiProto';
import { USER_AUTHENTICATING_STRING } from 'src/app/constants/authenticationConstants';

@Injectable({ providedIn: 'root' })
export class AuthenticationStoreService {
  userAccess: RoleUiPb[];
  constructor(
    public http: HttpClient,
    public _storageService: StorageService,
  ) {}

  /** Called once in APP_INITIALIZER */
  async loadUserAuthenticatedAccess(): Promise<any> {
    try {
      let authUser = this._storageService.getCookie('auth-user');

      if (authUser) {
        const data: any = await firstValueFrom(
          this.http
            .get(
              AppConfig.API_URL +
                AppConfig.FRON_END_API.USER_AUTHENTICATION +
                USER_AUTHENTICATING_STRING.STRING,
              {
                headers: {
                  apiName: 'User Authentication',
                },
              },
            )
            .pipe(map(this.transformUserAccess), shareReplay(1)),
        );

        this.userAccess = data;
        return data;
      }
    } catch (err) {
      this.userAccess = [];
      return [];
    }
  }
  private transformUserAccess(response: any): RoleUiPb[] {
    const str = response?.str?.[0];
    if (!str) return [];

    try {
      const parsedData = JSON.parse(str);
      return parsedData?.roleByProperty || [];
    } catch (error) {
      return [];
    }
  }
  getRoleForInventory(inventoryId: string): RoleUiPb {
    return this.userAccess?.filter((data) => data.topLevelEntityId == inventoryId)[0] || {};
  }
}
